// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608031438/js/" + chunkId + "." + {"44":"2fcbb0cb","225":"50b8e624","481":"5c2776b1","486":"a4a9649a","770":"bfc3548b"}[chunkId] + ".0.2892855427449115.chunk.js";
};